module.exports = __webpack_public_path__ + "static/media/slide1.0d5ef02f.png";